import styled from 'styled-components';
import InputMask from 'react-input-mask';
import { ReactComponent as Alert } from '../../assets/icons/alert.svg';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  font-size: 20px;
  padding: 52px 20px 40px 20px;

  @media screen and (max-width: 960px) {
    padding: 24px 20px 32px 20px;
    border-radius: 0%;
  }
`;

export const Content = styled.div`
  width: 624px;

  @media screen and (max-width: 960px) {
    width: auto;
  }
`;

export const Header = styled.div`
  width: 100%;
  button {
    font-size: 30px;
  }
`;

export const Title = styled.h2`
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
  color: ${(props) => props.theme.colors.primaryDark2};

  @media screen and (max-width: 960px) {
    font-size: 24px;
  }
`;

export const Description = styled.div`
  font-size: 20px;
  font-weight: 400;
  padding-left: 20px;
  color: ${(props) => props.theme.colors.black};
  line-height: 130%;

  @media screen and (max-width: 960px) {
    font-size: 16px;
    padding-left: 0;
    text-align: center;
  }
`;

export const EmailMask = styled.span`
  font-size: 20px;
  font-weight: 700;
  padding-left: 4px;
  color: ${(props) => props.theme.colors.black};

  @media screen and (max-width: 960px) {
    display: flex;
    justify-content: center;
    font-size: 16px;
    padding-top: 10px;
  }
`;

export const Subtitle = styled.h2`
  font-size: 20px;
  font-weight: 400;
  margin: 28px 0 32px 0;
  text-align: center;
  color: ${(props) => props.theme.colors.black};

  @media screen and (max-width: 960px) {
    font-size: 16px;
  }
`;

export const Input = styled(InputMask)<{ error: boolean }>`
  width: 100%;
  height: 72px;
  background: ${(props) => props.theme.colors.white};
  font-weight: 400;
  font-size: 22px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.18);
  text-align: center;
  border: none;
  margin-bottom: 28px;
  border: ${(props) =>
    props.error ? `2px solid ${props.theme.colors.danger}` : 'none'};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  button {
  }
`;

export const Button = styled.button<{ color: string }>`
  color: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.white
      : props.theme.colors.primary};
  background: ${(props) =>
    props.color === 'primary'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  font-weight: 700;
  font-size: 16px;
  padding: 0 24px;
  height: 60px;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  box-shadow: 0px 4px 4px rgba(36, 36, 36, 0.2);
  text-transform: uppercase;
  cursor: pointer;
`;

export const InfoContainer = styled.div`
  display: flex;
  margin-top: 32px;
`;

export const RecoverText = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  color: ${(props) => props.theme.colors.gray};
  margin-left: 19px;

  @media screen and (max-width: 960px) {
    width: calc(100% - 36px - 20px);
  }
`;

export const TextClick = styled.a`
  text-decoration: underline;
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
`;

export const IconAlert = styled(Alert)`
  width: 44px;
  height: 44px;

  @media screen and (max-width: 960px) {
    width: 36px;
    height: 36px;
  }
`;

export const TagError = styled.div`
  position: relative;
  z-index: 20;
  padding: 3px 8px 2px 8px;
  background: ${(props) => props.theme.colors.danger};
  font-weight: 700;
  text-align: center;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  width: max-content;
  border-radius: ${(props) =>
    Number(props.theme.borderRadius)
      ? `${props.theme.borderRadius}px`
      : '16px'};
  top: -38px;
  margin: 0 auto;
`;
